/* eslint-disable no-unused-vars */
import React from "react";
import moment from "moment";
import editIcon from "../assets/edit.svg";
import deleteIcon from '../assets/delete.svg';

export const MenuPlannerView = (props) => {
  const tableData = props.tableData || {};
  const {
    sectorDetails,
    sectorType,
    cateringStationDetails,
    catererDetails,
    fromDate,
    toDate,
    createdAt,
    status,
    menuSetting
  } = tableData;

  const sectorTypeLabel = sectorType?.label ?? (typeof sectorType === 'string' ? sectorType : (tableData.sectorTypeName || ""));
  const sectorVal = sectorDetails?.value ?? (typeof sectorDetails === 'string' ? sectorDetails : (tableData.sectorName || tableData.sector || ""));
  
  const whName = cateringStationDetails?.warehouseName || cateringStationDetails?.label || cateringStationDetails?.name || tableData.cateringStationName || (typeof cateringStationDetails === 'string' ? cateringStationDetails : '');
  const whCode = cateringStationDetails?.warehouseCode || cateringStationDetails?.value || cateringStationDetails?.code || tableData.cateringStationCode || '';
  const warehouseDisplay = whName ? (whCode ? `${whName} (${whCode})` : whName) : (tableData.cateringStation || tableData.cateringStationId || "N/A");

  const statusText = status ? (typeof status === 'string' ? status.charAt(0).toUpperCase() + status.slice(1) : String(status)) : "Active";

  const catName = catererDetails?.vendorName || catererDetails?.label || catererDetails?.name || tableData.catererName || (typeof catererDetails === 'string' ? catererDetails : '');
  const catCode = catererDetails?.vendorCode || catererDetails?.value || catererDetails?.code || tableData.catererCode || '';
  const catererDisplay = catName ? (catCode ? `${catName} (${catCode})` : catName) : (tableData.caterer || tableData.catererId || "N/A");

  return (
    <>
      {menuSetting && menuSetting.length > 0 ? (
        <>
          <div className="flexRow justifyContentSpaceBetween">
            <h6 className="mb-3">Menu Details</h6>
            <div className="flexRow justifyContentFlexEnd">
              {status !== 'expired' ? (
                <img
                  style={{ marginLeft: '5px', width: '35px', height: '25px', border: '1px solid #70CEEA', borderRadius: '4px', backgroundColor: "#70CEEA" }}
                  className='aircraft-actions'
                  alt='edit'
                  onClick={() => { props.action && props.action(props.tableData, 'editMenuPlan'); }}
                  src={editIcon}
                />
              ) : null}
              <img
                style={{ marginLeft: '5px', width: '35px', height: '25px', border: '1px solid #F06548', borderRadius: '4px', backgroundColor: '#F06548' }}
                className='aircraft-actions'
                alt='delete'
                onClick={() => { props.action && props.action(props.tableData, 'deleteMenuPlan'); }}
                src={deleteIcon}
              />
            </div>
          </div>
          <table>
            <tbody>
              <tr>
                <th style={{ width: "50%" }}>Sector Type</th>
                <td style={{ width: "50%" }}>{sectorTypeLabel}</td>
              </tr>
              <tr>
                <th style={{ width: "50%" }}>Sector</th>
                <td style={{ width: "50%" }}>{sectorVal}</td>
              </tr>
              <tr>
                <th style={{ width: "50%" }}>Warehouse</th>
                <td style={{ width: "50%" }}>{warehouseDisplay}</td>
              </tr>
              <tr>
                <th style={{ width: "50%" }}>Status</th>
                <td style={{ width: "50%" }}>{statusText}</td>
              </tr>
              <tr>
                <th style={{ width: "50%" }}>Caterer</th>
                <td style={{ width: "50%" }}>{catererDisplay}</td>
              </tr>
              <tr>
                <th>From Date</th>
                <td>{fromDate ? moment(fromDate).format('DD/MM/YY') : ''}</td>
              </tr>
              <tr>
                <th>To Date</th>
                <td>{toDate ? moment(toDate).format('DD/MM/YY') : ''}</td>
              </tr>
              <tr>
                <th>Menu Created At</th>
                <td>{createdAt ? moment(createdAt).format('DD/MM/YY') : ''}</td>
              </tr>
            </tbody>
          </table>

          <table className="mt-3" frame="true" bgcolor="transparent" rules="rows" summary="Show order items">
            <thead>
              <tr>
                <th colSpan="2" style={{ textAlign: "center" }}>Menu</th>
              </tr>
              <tr>
                <th>Meal Type</th>
                <th>Items/Brands</th>
              </tr>
            </thead>
            <tbody>
              {menuSetting?.slice().sort((a, b) => {
                const catIdA = parseInt(String(a?.mealCategoryId || '').split('-').pop()) || 0;
                const catIdB = parseInt(String(b?.mealCategoryId || '').split('-').pop()) || 0;
                return catIdA - catIdB;
              }).map((cat, catIndex) => (
                <React.Fragment key={cat.mealCategoryId || catIndex}>
                  {cat.mealsSelection && cat.mealsSelection.length > 0 ? (
                    <tr>
                      <td colSpan="2" className="spl-row-class" style={{ textAlign: "center", width: "50%", fontSize: '125%', fontWeight: 'bold' }}>
                        {cat.mealName || ""}
                      </td>
                    </tr>
                  ) : null}
                  {cat.mealsSelection && cat.mealsSelection.map((meal, mealIndex) =>
                    meal.items && meal.items.map((item, itemIndex) => (
                      <React.Fragment key={item.itemId || `${catIndex}-${mealIndex}-${itemIndex}`}>
                        {mealIndex === 0 || itemIndex === 0 || meal.mealType !== cat?.mealsSelection?.[mealIndex - 1]?.mealType ? (
                          <tr>
                            {mealIndex === 0 || itemIndex === 0 ? (
                              <td>{meal.mealType}</td>
                            ) : (
                              <td></td>
                            )}
                            <td style={{ width: "50%" }}>{item.itemName}</td>
                          </tr>
                        ) : (
                          <tr>
                            <td></td>
                            <td style={{ width: "50%" }}>{item.itemName}</td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <div className="loadingDiv">Loading...</div>
      )}
    </>
  );
};